import { Reveal } from "../components/site/Reveal";

const sections = [
  {
    title: "Information we collect",
    body: [
      "When you submit an enquiry through our website contact form, we collect: your name, email address, phone number, project location, project type, approximate budget, and details you provide about your project.",
    ],
  },
  {
    title: "How we use your information",
    body: [
      "We use this information solely to respond to your enquiry, discuss your project, and provide quotes or services you've requested. We do not sell or share your personal information with third parties for marketing purposes.",
    ],
  },
  {
    title: "Website analytics and advertising",
    body: [
      "Our website uses Google Ads and Google Analytics tracking technologies (including cookies) to understand how visitors use our site and to measure the effectiveness of our advertising. These tools may collect information such as your IP address, browser type, pages visited, and general location. This data is used to improve our website and advertising, and is processed in accordance with Google's own privacy policy.",
    ],
  },
  {
    title: "Data storage and security",
    body: [
      "Information submitted via our contact form is stored securely and only accessed by authorised Tidemark Building Co. personnel. We retain enquiry information only as long as necessary to respond to your enquiry or fulfil a business relationship.",
    ],
  },
  {
    title: "Your rights",
    body: [
      <>
        You may request access to, correction of, or deletion of your personal
        information at any time by contacting us at{" "}
        <a
          href="mailto:info@tidemarkbuildingco.com.au"
          className="text-zinc-200 underline underline-offset-4 hover:text-white transition-colors"
        >
          info@tidemarkbuildingco.com.au
        </a>
        .
      </>,
    ],
  },
  {
    title: "Changes to this policy",
    body: [
      "We may update this policy from time to time. The most current version will always be available on this page.",
    ],
  },
];

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page" className="bg-zinc-950">
      <section className="pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <div className="text-[11px] tracking-[0.3em] uppercase text-zinc-500">
              — Legal
            </div>
            <h1 className="mt-6 font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-zinc-100 leading-[1.02] max-w-5xl">
              Privacy Policy
            </h1>
            <p className="mt-8 text-zinc-400 text-lg max-w-2xl leading-relaxed">
              Tidemark Building Co. (&ldquo;we&rdquo;, &ldquo;us&rdquo;,
              &ldquo;our&rdquo;) is committed to protecting your privacy in
              accordance with the Australian Privacy Principles (APPs) under
              the Privacy Act 1988 (Cth).
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-24 sm:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4" />
          <div className="md:col-span-8">
            <div className="space-y-14 max-w-2xl">
              {sections.map((s, i) => (
                <Reveal key={s.title} delay={i * 0.05}>
                  <div>
                    <h2 className="font-serif text-2xl sm:text-3xl text-zinc-100 tracking-tight">
                      {s.title}
                    </h2>
                    {s.body.map((p, j) => (
                      <p
                        key={j}
                        className="mt-4 text-zinc-400 leading-relaxed"
                      >
                        {p}
                      </p>
                    ))}
                  </div>
                </Reveal>
              ))}

              <Reveal delay={0.3}>
                <div className="pt-6 border-t border-zinc-900 text-[11px] tracking-[0.25em] uppercase text-zinc-600">
                  Last updated: 14/07/2026
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
